<template>
  <div class="row mb-3">
    <div class="col-12 suplementar-text text-center">
      {{ $t('ct-first-website-help') }}
    </div>

    <div class="col-12 d-flex justify-content-center">
      <div class="place-helpers">
        <div class="place-helper-info">
          <div class="img-helpers" style="background-image: url('static/images/firstWebsite/coracao.svg')"></div>
          <h2>{{ $t('ct-first-website-tutoriais') }}</h2>
          <span>{{ $t('ct-first-website-tutoriais-desc') }}</span>
        </div>
        <a class="place-helper-link"
           :href="($i18n.locale === 'pt_BR') ? 'https://office.builderall.com/es/office/dashboard-training?category=43&video=6508': 'https://knowledgebase.builderall.com/'"
           target="_blank">{{ $t('ct-first-website-tutoriais-goto') }}
          <img src="static/images/firstWebsite/seta.svg"
          ></a>
      </div>

      <div class="place-helpers">
        <div class="place-helper-info">
          <div class="img-helpers" style="background-image: url('static/images/firstWebsite/suporte.svg')"></div>
          <h2>{{ $t('ct-first-website-support') }}</h2>
          <span>{{ $t('ct-first-website-support-desc') }}</span>
        </div>
        <a class="place-helper-link"
           :href="($i18n.locale === 'pt_BR') ? 'https://ajuda.builderall.com/' :'https://office.builderall.com/us/office/support/ticket'"
           target="_blank">{{
            $t('ct-first-website-support-goto')
          }} <img src="static/images/firstWebsite/seta.svg"
          ></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionHelpTemplate"
}
</script>

<style lang="scss" scoped>
.suplementar-text {
  text-align: left;
  font: 18px/26px Muli;
  letter-spacing: 0;
  color: #434343;
  opacity: 1;
  margin-bottom: 50px;
}

.place-helpers {
  background: #FFFFFF no-repeat padding-box;
  box-shadow: 0 0 20px #E1E4ED;
  border: 1px solid #7070704D;
  border-radius: 10px;
  opacity: 1;
  margin-right: 30px;
  padding: 30px;
  margin-bottom: 30px;
  width: calc(25% - 30px);
  transition: .3s box-shadow cubic-bezier(0.47, 0, 0.75, 0.72);

  .img-helpers {
    width: 50px;
    height: 48px;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 30px;
  }

  .place-helper-info {

  }

  h2 {
    text-align: left;
    font: 20px/23px Muli;
    letter-spacing: 0px;
    font-weight: 900;
    color: #0F7BFF;
    opacity: 1;
    margin-bottom: 20px;
  }

  a,
  span {
    text-align: left;
    font: 16px/22px Lato;
    letter-spacing: 0px;
    color: #434343;
    opacity: 0.8;
  }

  a {
    display: none;
    font-weight: 700;
  }
}

.place-helpers:hover {
  background: transparent linear-gradient(31deg, #0294FF 0%, #0AFFF7 100%) 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 20px #6852EDCC;
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .img-helpers {
    display: none;
  }

  .place-helper-link {
    display: flex;
    justify-content: space-between;
  }

  a {
    display: block;
    text-decoration: none;
  }

  a,
  span,
  h2 {
    color: #FFFFFF;
  }
}

@media (max-width: 990px) {
  .place-helpers {
    width: 100% !important;
    text-align: center;

    * {
      text-align: center !important;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/SectionHelpTemplate.vue